import * as Types from './types';
import { TJackpots, IJackpot } from '../types';
import { actionTypes } from './constants';

export const setJackpots = (jackpots: TJackpots): Types.ISetJackpotsAction => ({
    type: actionTypes.SET_JACKPOTS,
    payload: jackpots
});

export const setCasinoJackpot = (casinoJackpot: IJackpot): Types.ISetCasinoJackpotsAction => ({
    type: actionTypes.SET_CASINO_JACKPOT,
    payload: casinoJackpot
});
